<template>
  <div class="fb-eoc-active-medications-v11">
    <div v-if="showType == 'form-builder'" :style="properties.style">
      <b-form-group
        :description="
          superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'description',
            value: properties.description,
            defaultValue: '',
            form: this.form
          })
        "
        :label="
          superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'label',
            value: properties.label,
            defaultValue: '',
            form: this.form
          })
        "
        :style="properties.style"
      >
        <b-button variant="primary" class="float-right m-3" text="Add scheduled medication<"><i class="fa fa-plus"></i></b-button>
        <fb-table-v1
          :showType="showType"
          :properties="tableProperties"
          :id="id"
          :form="form"
        ></fb-table-v1>
      </b-form-group>
    </div>
    <div v-else-if="showType == 'properties'">
      <eoc-active-medications-v1-properties :formId="formId" />
    </div>
    <div
      v-if="showType == 'form-submitter' ||
          (showType == 'e-form' && properties.eFormEditable)"
      :style="properties.style"
      class="medication-table-container"
      v-show="!computedHidden"
    >
      <b-form-group
        :description="
          superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'description',
            value: properties.description,
            defaultValue: '',
            form: this.form
          })
        "
        :style="properties.style"
      >
        <template v-slot:label="">
          <div class="d-flex align-items-center justify-content-between">
            <span style="font-size:16px;" class="mr-3">
              {{
                superComputeFormSubmitterValue({
                  elementId: id,
                  property: "label",
                  value: properties.label,
                  defaultValue: "",
                  form: form
                })
              }}
            </span>
            <b-button variant="primary" v-if="!properties.hideAddButton" @click="openScheduledMedicationModal" class="float-right m-3" text="Add scheduled medication<"><i class="fa fa-plus"></i></b-button>
         
          </div>
        </template>
         <b-table
            class="custom-fb-table"
            striped
            hover
            :items="tableProperties.items"
            :fields="tableProperties.columns"
          >
            <template #cell(action)="row">
              <img
                class="b-action-item"
                @click="deleteRow(row.index)"
                src="/icons/delete.svg"
                width="16px"
                style="margin-left: 21px;"
              />
            </template>
          </b-table>
      </b-form-group>
    </div>
    <div
      v-if="showType == 'form-viewer'"
      :style="properties.style"
      class="medication-table-container"
    >
      <fb-table-v1
        :showType="showType"
        :properties="tableProperties"
        :id="id"
        :form="form"
      ></fb-table-v1>
    </div>
    <b-modal
      centered
      ref="form-scheduled-modal"
      title="Add scheduled medication"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="addScheduledMedication"
      no-close-on-backdrop
      size="md-lg"
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <b-row>
        <b-col>
          <b-form-group
            label="Medication"
            :state="formScheduledErrors.medication.length == 0 ? null : false"
            :invalid-feedback="formScheduledErrors.medication.join(', ')"
          >
            <v-select
              placeholder="Search for medications"
              v-model="formScheduled.medication"
              @search="searchMedications"
              :options="medications"
              :class="medications.length == 0 ? 'picker-hide-options' : ''"
            >
              <template #open-indicator> <span></span> </template>
            </v-select>
          </b-form-group>
          <b-form-group
            label="Route"
            :state="formScheduledErrors.route.length == 0 ? null : false"
            :invalid-feedback="formScheduledErrors.route.join(', ')"
          >
            <v-select
              class=""
              placeholder=""
              v-model="formScheduled.route"
              :options="medicationRoutes"
            ></v-select>
          </b-form-group>
          <b-row>
            <b-col>
              <b-form-group
                label="Dosage"
                :state="formScheduledErrors.dosage.length == 0 ? null : false"
                :invalid-feedback="formScheduledErrors.dosage.join(', ')"
              >
                <b-form-input
                  placeholder=""
                  v-model="formScheduled.dosage"
                  type="number"
                  trim
                  :state="formScheduledErrors.dosage.length == 0 ? null : false"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Unit of measurement"
                :state="
                  formScheduledErrors.measurementUnit.length == 0 ? null : false
                "
                :invalid-feedback="
                  formScheduledErrors.measurementUnit.join(', ')
                "
              >
                <v-select
                  class=""
                  placeholder=""
                  v-model="formScheduled.measurementUnit"
                  :options="measurements"
                ></v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group
            label="Start Date"
            :state="formScheduledErrors.startDate.length == 0 ? null : false"
            :invalid-feedback="formScheduledErrors.startDate.join(', ')"
          >
            <date-time-picker
              v-model="formScheduled.startDate"
              :errors="formScheduledErrors.startDate"
              :max="formScheduled.endDate ? formScheduled.endDate : null"
            />
          </b-form-group>
          <b-form-checkbox v-model="formScheduled.untilDischarge">
            Until Discharge
          </b-form-checkbox>
          <b-form-group
            label="End Date"
            :state="formScheduledErrors.endDate.length == 0 ? null : false"
            :invalid-feedback="formScheduledErrors.endDate.join(', ')"
            :disabled="formScheduled.untilDischarge"
          >
            <date-time-picker
              v-model="formScheduled.endDate"
              :errors="formScheduledErrors.endDate"
              :min="formScheduled.startDate ? formScheduled.startDate : null"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Type">
            <v-select
              class=""
              placeholder=""
              v-model="formScheduled.type"
              :options="types"
            ></v-select>
          </b-form-group>
          <b-form-group v-if="formScheduled.type == 'SCH'" label="Frequency">
             <b-form-input
              placeholder=""
              v-model="formScheduled.frequency"
              trim
            ></b-form-input>
          </b-form-group>
          <b-form-group
            v-if="formScheduled.type == 'SCH'"
            label="Times per day"
            :state="
              formScheduledErrors.timesPerDayId.length == 0 ? null : false
            "
            :invalid-feedback="formScheduledErrors.timesPerDayId.join(', ')"
          >
            <v-select
              class=""
              placeholder=""
              v-model="timesPerDay"
              :options="timesPerDayOptions"
            ></v-select>
          </b-form-group>
          <b-form-group
            v-if="formScheduled.type == 'SCH'"
            label="Times"
            :state="formScheduledErrors.medication.length == 0 ? null : false"
            :invalid-feedback="formScheduledErrors.medication.join(', ')"
          >
            <div
              class="times-container rounded border w-100 d-flex flex-wrap justify-content-start align-items-start p-2"
            >
              <div
                v-for="timeIndex in Object.keys(formScheduled.times)"
                :key="timeIndex"
                class="mr-2"
              >
                <b-form-select
                  :options="timeOptions"
                  :value="formScheduled.times[timeIndex]"
                  @input="newValue => setTime(timeIndex, newValue)"
                ></b-form-select>
              </div>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Instructions">
            <b-form-input
              placeholder=""
              v-model="formScheduled.instructions"
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import EocActiveMedicationsV1Properties from "./EocActiveMedicationsV1Properties.vue";
import scheduledMedicationServer from "../../../../server/scheduledMedication";
import prnMedicationServer from "../../../../server/prnMedication";
import medicationServer from "../../../../server/medication";
import { formatDate, formatTimeOnly } from "../../../../helpers/date";
import DateTimePicker from "../../../controls/DateTimePicker.vue";
import {
  daysIntervals,
  timesPerDayOptions,
  timeOptions
} from "../../../../config/form_builder/components/eoc_active_medications/medications";
import moment from "moment";

export default {
  name: "EocActiveMedicationsV1",
  components: { EocActiveMedicationsV1Properties, DateTimePicker },
  props: ["showType", "properties", "form", "id", "formId"],
  data() {
    return {
      medications: [],
      computedProperties: ["description", "label", "hidden"],
      types: ['SCH', 'PRN'],
      computedConditions: {},
      medicationRecords: [],
      formScheduled: {
        medication: null,
        route: null,
        dosage: "",
        measurementUnit: null,
        startDate: null,
        endDate: null,
        untilDischarge: false,
        frequency: "",
        timesPerDayId: null,
        times: [],
        instructions: "",
        type: "SCH"
      },
      formScheduledErrors: {
        medication: [],
        route: [],
        dosage: [],
        measurementUnit: [],
        startDate: [],
        endDate: [],
        timesPerDayId: []
      }
    };
  },
  async mounted() {
    this.fetchData();
    
    if (this.showType != "form-builder") {
      const currentDate = moment();

      if (this.getFormSubmitterComponentValue(this.id) &&
        this.showType == "form-submitter"
      ) {
        this.medicationRecords = this.getFormSubmitterComponentValue(this.id);
      } else {
        const scheduledList = await scheduledMedicationServer.query(
          this.client.episodeOfCare.id,
          {}
        );

        const prnList = await prnMedicationServer.query(this.client.episodeOfCare.id, {});

        if (this.properties.type.toLowerCase() == "sch" || this.properties.type.toLowerCase() == "both") {
          this.medicationRecords = scheduledList.filter(m => currentDate.isBetween(moment(m.startDate), moment(m.endDate))).map(medication => ({
            ...medication,
            dateRange: `${formatDate(medication.startDate)} - ${
              medication.untilDischarge
                ? "Until Discharge"
                : formatDate(medication.endDate)
            }`,
            type: "SCH",
            medicationLabel: `${medication.medication?.name}, ${medication.dosageAmount} ${medication.unitOfMeasurement?.name} by ${medication.medicationRoute?.name}`,
            times: `${medication.times.map(time => formatTimeOnly(time, "HH:mm")).join(", ")}`,
            frequency: this.getFrequencyLabel(medication)
          }));
        }
        
        if (this.properties.type.toLowerCase() == "prn" || this.properties.type.toLowerCase() == "both") {
          this.medicationRecords = this.medicationRecords.concat(prnList.filter(m => currentDate.isBetween(moment(m.startDate), moment(m.stopDate))).map(medication => ({
            ...medication,
            dateRange: `${formatDate(medication.startDate)} - ${formatDate(medication.stopDate)}`,
            type: "PRN",
            medicationLabel: `${medication.medication?.name}, ${medication.dosageAmount} ${medication.unitOfMeasurement?.name} by ${medication.medicationRoute?.name}`
          })));
        }
      }
    }
    const preCode = `patient.episodeOfCare.medications = ${JSON.stringify(
      this.medicationRecords
    )};`;
    if (
      this.showType == "form-submitter" &&
      this.properties.value.includes("{{")
    ) {
      this.medicationRecords = this.superComputeFormSubmitterValue({
        elementId: this.id,
        property: "value",
        value: this.properties.value,
        defaultValue: "",
        form: this.form,
        preCode: preCode
      });
    }

    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentValue"]),
    ...mapActions("client", [
      "fetchMedicationRoutes",
      "fetchMeasurements"
    ]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property]
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      this.setFormSubmitterComponentValue({
        controlId: this.id,
        controlValue: this.medicationRecords,
        userAction: true,
        hardSet: true
      });
      return `
      <fieldset aria-describedby="" class="form-group is-table" id="__BVID__48">
        <legend style="font-size:16px;" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0" id="__BVID__48__BV_label_">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <div>
            <div>
              <table role="table" aria-busy="false" aria-colcount="3" class="table b-table custom-fb-table mt-2 table-striped table-hover" id="__BVID__50">
                <thead role="rowgroup" class="">
                  <tr role="row" class="">
                    <th role="columnheader" scope="col" aria-colindex="1" class="">
                      <div>Date Range</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="2" class="">
                      <div>Type</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="3">
                      <div>Medication</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="4">
                      <div>Times</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="5">
                      <div>Frequency</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="5">
                      <div>Instructions</div>
                    </th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                ${(this.tableProperties.items || [])
                  .map(
                    item => `
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="" style="min-width: 130px;">${
                      item.dateRange
                    }</td>
                    <td aria-colindex="2" role="cell" class="" style="min-width: 130px;">${
                      item.type
                    }</td>
                    <td aria-colindex="3" role="cell" style="min-width: 130px;">${
                      item.medicationLabel
                    }</td>
                    <td aria-colindex="3" role="cell" style="min-width: 130px;">${
                      item.times
                    }</td>
                    <td aria-colindex="3" role="cell" style="min-width: 130px;">${
                      item.frequency
                    }</td>
                    <td aria-colindex="3" role="cell" style="min-width: 130px;">${
                      item.instructions
                    }</td>
                  </tr>
                `
                  )
                  .join("")}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </fieldset>`;
    },
    deleteRow(rowIndex) {
      const medications = [...this.medicationRecords];
      medications.splice(rowIndex, 1);
      this.medicationRecords = medications;
    },
    openScheduledMedicationModal() {
      this.formScheduled = {
        medication: null,
        route: null,
        dosage: "",
        measurementUnit: null,
        startDate: null,
        untilDischarge: false,
        endDate: null,
        timesPerDayId: null,
        times: [],
        instructions: "",
        type: "SCH"
      };
      this.formScheduledErrors = {
        medication: [],
        route: [],
        dosage: [],
        measurementUnit: [],
        startDate: [],
        endDate: [],
        timesPerDayId: []
      };
      this.$refs["form-scheduled-modal"].show();
    },
    addScheduledMedication(){
       this.medicationRecords.push({
        dateRange: `${formatDate(this.formScheduled.startDate)} - ${
          this.formScheduled.untilDischarge
            ? "Until Discharge"
            : formatDate(this.formScheduled.endDate)
        }`,
        type: this.formScheduled.type,
        medicationLabel: `${this.formScheduled.medication? this.formScheduled.medication.label : ""}, ${this.formScheduled.dosage} ${this.formScheduled.measurementUnit?this.formScheduled.measurementUnit.label: ""} by ${this.formScheduled.route?this.formScheduled.route.label: ""}`,
        times: this.formScheduled.type == "SCH" ? `${Object.values(this.formScheduled.times).map(time => formatTimeOnly(time, "HH:mm")).join(", ")}` : "",
        frequency: this.formScheduled.type == "SCH" ? this.formScheduled.frequency : "",
        instructions: this.formScheduled.instructions
      });
    },
    fetchData() {
      this.fetchMedicationRoutes();
      this.fetchMeasurements();
    },
    async searchMedications(search, loading) {
      if (this.lastTimeout) {
        clearTimeout(this.lastTimeout);
        this.lastTimeout = null;
      }
      if (search && search.trim().length >= 3) {
        this.medications = [];
      }

      this.lastTimeout = setTimeout(async () => {
        loading(true);
        if (search.trim().length >= 3) {
          const medications = await medicationServer.query(
            { searchPhrase: search, page: 0, pageSize: 10, orderBy: "name" },
            { "Hide-Loading": true }
          );
          this.medications = medications.map(m => ({
            value: m.id,
            label: m.name
          }));
        } else {
          this.medications = [];
        }
        loading(false);
      }, 1000);
    },
    initializeTimes() {
      if (!this.formScheduled.timesPerDayId) {
        this.formScheduled.times = [];
      } else {
        let newTimes = {};
        for (
          let index = 0;
          index <
          timesPerDayOptions[this.formScheduled.timesPerDayId].initialTimes
            .length;
          index++
        ) {
          const initialTime =
            timesPerDayOptions[this.formScheduled.timesPerDayId].initialTimes[
              index
            ];
          newTimes[index] = initialTime;
        }
        this.formScheduled.times = newTimes;
      }
    },
    getDaysIntervalId(intervalLabel, intervalAmount) {
      switch (`${intervalAmount}${intervalLabel}`) {
        case "2Days":
          return "every2Days";
        case "3Days":
          return "every3Days";
        case "1Weeks":
          return "1timePerWeek";
        case "2Weeks":
          return "everyTwoWeeks";
        case "3Weeks":
          return "every3Weeks";
        case "28Days":
          return "every28Days";
        case "30Days":
          return "every30Days";

        default:
          return null;
      }
    },
    getFrequencyLabel(medication){
      switch (medication.frequency) {
        case "EveryDay":
          return "Every Day";
        case "DaysInterval":
          return daysIntervals[
            this.getDaysIntervalId(
              medication.interval,
              medication.intervalAmount
            )
          ].label;
        case "DaysOfWeek":
          return [
            ...(medication.sunday ? ["Sunday"] : []),
            ...(medication.monday ? ["Monday"] : []),
            ...(medication.tuesday ? ["Tuesday"] : []),
            ...(medication.wednesday ? ["Wednesday"] : []),
            ...(medication.thursday ? ["Thursday"] : []),
            ...(medication.friday ? ["Friday"] : []),
            ...(medication.saturday ? ["Saturday"] : [])
          ].join(", ");
        default:
          return "";
      }
    },
    setTime(timeIndex, newTime) {
      this.formScheduled.times[timeIndex] = newTime;
    },
  },
  computed: {
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "superComputeFormSubmitterValue",
      "computeFormSubmitterValue"
    ]),
    ...mapState("formSubmitter", {
      client: state => state.form.client
    }),
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      }
    }),
    ...mapState("client", {
      medicationRoutes: state =>
        state.medicationRoutes.map(medicationRoute => ({
          value: medicationRoute.id,
          label: medicationRoute.name
        })),
      measurements: state =>
        state.measurements.map(measurement => ({
          value: measurement.id,
          label: measurement.name
        }))
    }),
    timesPerDayOptions() {
      return Object.values(timesPerDayOptions).map(t => ({
        value: t.key,
        label: t.label
      }));
    },
    timesPerDay: {
      get() {
        return this.formScheduled.timesPerDayId
          ? this.timesPerDayOptions.find(
              timesPerDay =>
                timesPerDay.value == this.formScheduled.timesPerDayId
            )
          : null;
      },
      set(newValue) {
        this.formScheduled.timesPerDayId = newValue ? newValue.value : null;
        this.initializeTimes();
      }
    },
    timeOptions() {
      return timeOptions.map(t => ({
        value: t,
        text: formatTimeOnly(t, "HH:mm")
      }));
    },
    tableProperties() {
      let items = this.medicationRecords;
      return {
        ...this.properties,
        items: items,
        columns: [
          {
            key: "dateRange",
            label: "Date Range"
          },
          {
            key: "type",
            label: "Type"
          },
          {
            key: "medicationLabel",
            label: "Medication"
          },
          {
            key: "times",
            label: "Times"
          },
          {
            key: "frequency",
            label: "Frequency"
          },
          {
            key: "instructions",
            label: "Instructions"
          },
          {
            key: "action",
            label: "Actions"
          }
        ]
      };
    },
    computedHidden(){
      const hiddenValue = this.computedConditions.hidden
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'hidden',
            value: this.properties.hidden,
            defaultValue: false,
            form: this.form
          })
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>

<style scoped>
.medication-table-container >>> td {
  min-width: 130px;
}
.custom-fb-table th,
.custom-fb-table td {
  padding: 5px !important;
  vertical-align: middle !important;
}
.custom-fb-table td {
  font-size: 12px;
  padding-left: 17px;
}
.custom-fb-table th {
  font-size: 14px;
  padding-left: 17px;
}
</style>
